module.exports = __webpack_public_path__ + "images/paprika-412763feedc45f0837907b7bc6ee2daa.jpeg";


//////////////////
// WEBPACK FOOTER
// ./app/frontend/images/paprika.jpeg
// module id = 230
// module chunks = 0